import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TextModule } from '@library/ui/atoms/text/text.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { LocalStorageService } from '@library/utils/services/local-storage.service';
import { WeathermapFacade } from '@store/weathermap.facade';
import { RainScale, TemperatureQuality, WindType } from '@store/weathermap.store';
import { LayersService } from 'src/app/services/layers.service';
import { ToolbarSectionComponent } from 'src/app/toolbar/toolbar-panel/toolbar-section/toolbar-section.component';
import { ToolbarSelectItemComponent } from 'src/app/toolbar/toolbar-panel/toolbar-select-item/toolbar-select-item.component';
import { RAIN_SCALE_CACHE_KEY, TEMPERATURE_QUALITY_CACHE_KEY, WIND_TYPE_CACHE_KEY } from 'src/app/weathermap.const';

@Component({
  selector: 'app-filters',
  imports: [
    TextModule,
    ToolbarSectionComponent,
    ToolbarSelectItemComponent,
    PipesModule,
  ],
  templateUrl: './filters.component.html',
  styleUrl: './filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiltersComponent {
  private readonly weathermapFacade = inject(WeathermapFacade);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly layersService = inject(LayersService);

  RainScale = RainScale;
  TemperatureQuality = TemperatureQuality;
  WindType = WindType;

  temperatureQuality = this.weathermapFacade.temperatureQuality;
  rainScale = this.weathermapFacade.rainScale;
  windType = this.weathermapFacade.windType;

  selectRainScale(rainScale: RainScale): void {
    this.weathermapFacade.selectRainScale(rainScale);
    this.localStorageService.setItem(RAIN_SCALE_CACHE_KEY, rainScale);
    this.layersService.reloadLayers();
  }

  selectTemperatureQuality(temperatureQuality: TemperatureQuality): void {
    this.weathermapFacade.selectTemperatureQuality(temperatureQuality);
    this.localStorageService.setItem(TEMPERATURE_QUALITY_CACHE_KEY, temperatureQuality);
    this.layersService.reloadLayers();
  }

  selectWindType(windType: WindType): void {
    this.weathermapFacade.selectWindType(windType);
    this.localStorageService.setItem(WIND_TYPE_CACHE_KEY, windType);
    this.layersService.reloadLayers();
  }
}
